import { Link } from 'react-router-dom';
import { navCategories } from '@/mocks/navigationData';

export default function CategoryNav() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 -mt-8 relative z-20">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
        {navCategories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group bg-background-50 rounded-2xl p-4 md:p-5 border border-background-200 hover:border-primary-300 transition-all duration-300 hover:-translate-y-0.5"
          >
            <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-200 group-hover:scale-110 transition-all duration-300">
              <i className={`${cat.icon} text-xl md:text-2xl`}></i>
            </div>
            <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-1 whitespace-nowrap">
              {cat.name}
            </h3>
            <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
              {cat.description}
            </p>
            <div className="mt-3 flex items-center gap-1 text-xs text-primary-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              <span>浏览全部</span>
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}